module.exports = __webpack_public_path__ + "img/54.673699df.jpg";